module.exports = __webpack_public_path__ + "static/media/trimex_extrafina_sanmarcos_asmsa.eab95dd6.png";